<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <uklon_market_general_tab :location="location"></uklon_market_general_tab>
        </template>

        <template v-slot:uklon_market_seller="{ location, name }">
            <uklon_market_seller :location="location"></uklon_market_seller>
        </template>

        <template v-slot:uklon_image_tab="{ location, name }">
            <uklon_image_tab :location="location"></uklon_image_tab>
        </template>

        <template v-slot:uklon_market_labels="{ location, name }">
            <uklon_market_labels :location="location"></uklon_market_labels>
        </template>

    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import uklon_market_general_tab from "./tabs/uklon_market_general_tab.vue";
import uklon_market_seller from "./tabs/uklon_market_seller.vue";
import uklon_image_tab from "./tabs/uklon_image_tab.vue";
import uklon_market_labels from "./tabs/uklon_market_labels.vue";

export default {
    name: "uklon_retail_location_modal",
    components : {
        uklon_market_labels,
        base_location_modal,
        uklon_market_general_tab,
        uklon_market_seller,
        uklon_image_tab

    },
    data () {
        return {
            tabs_add : [
                {
                    index : "uklon_market_labels",
                    title : this.__t('UKLON_LABELS'),
                },

                 {
                     index : "uklon_market_seller",
                     title : this.__t('UKLON_DATA'),
                 },

                 {
                     index : "uklon_image_tab",
                     title : this.__t('UKLON_IMAGE'),
                 },
            ]
        }
    },

}
</script>

<style scoped>

</style>
